import React from 'react';
import {TFunction} from 'i18next';
import {convertToHtml} from '../../whatsAppTemplateEditor/utils/formatUtils';
import {TemplateStructure} from '../../whatsAppTemplateEditor/types/templateStructure';
import sanitizeHtml from '../../../library/sanitizeHtml';
import {toCamelCase} from '../../../functions/camelSnakeCaseConversion';
import LinkIcon from '../../../pages/branding/whatsAppScreen/whatsAppPreview/linkIcon/LinkIcon';
import * as css from './formatDraftMessage.css';

export function formatDraftMessage(
    text: string,
    defaultVariables: Record<string, string>,
    t: TFunction,
    parameterValues?: TemplateStructure,
    currentLang?: string
): React.ReactNode {
    const whatsappButtons = parameterValues?.filter(item => item.type === 'button') ?? [];

    if(!text && !whatsappButtons.length) {
        return null;
    }

    const messageHtml = text ? convertToHtml(text, defaultVariables, t) : null;

    return (
        <>
            {messageHtml && <span dangerouslySetInnerHTML={sanitizeHtml(messageHtml)} />}
            {whatsappButtons.length > 0 && (
                <css.buttonContainer>
                    {whatsappButtons.map((button, index) => (
                        <css.linkButton key={index}>
                            {t(toCamelCase(button.value.replace(/[[\]]/g, '')), {lng: currentLang})}
                            <LinkIcon />
                        </css.linkButton>
                    ))}
                </css.buttonContainer>
            )}
        </>
    );
}
